import LayoutOrIframe from '@/layouts/LayoutOrIframe.vue'

export default [
  {
    path: '/upload',
    component: LayoutOrIframe,
    name: 'upload',
    redirect: 'upload-id',
    children: [
      {
        path: '/upload/:id?',
        component: () => import('@/pages/upload/UploadIndex.vue'),
        name: 'upload-id',
        meta: {
          auth: false,
        },
      },
    ],
  },
]
